export default "__VITE_ASSET__DapleCTZ__"